import { Reorder, useDragControls } from "framer-motion";
import { GripVertical, ChevronUp, ChevronDown } from "lucide-react";

const btn = "w-7 h-7 grid place-items-center rounded-md text-gray-500 hover:bg-[#FFF0F0] hover:text-[#E60000] disabled:opacity-30 disabled:hover:bg-transparent transition-colors";

export const MoveControls = ({ i, count, onMove, onGrab, testId, vertical }) => (
  <div className={`flex ${vertical ? "flex-col" : ""} items-center shrink-0`} data-testid={`${testId}-controls`}>
    <button type="button" onPointerDown={onGrab} className={`${btn} cursor-grab active:cursor-grabbing touch-none`} aria-label="Drag to reorder" title="Drag to reorder" data-testid={`${testId}-drag`}><GripVertical className="w-4 h-4" /></button>
    <button type="button" onClick={() => onMove(i, -1)} disabled={i === 0} className={btn} aria-label="Move up" title="Move up" data-testid={`${testId}-up`}><ChevronUp className="w-4 h-4" /></button>
    <button type="button" onClick={() => onMove(i, 1)} disabled={i === count - 1} className={btn} aria-label="Move down" title="Move down" data-testid={`${testId}-down`}><ChevronDown className="w-4 h-4" /></button>
  </div>
);

const SortItem = ({ item, i, count, onMove, render, testId }) => {
  const controls = useDragControls();
  const handle = <MoveControls i={i} count={count} onMove={onMove} onGrab={(e) => controls.start(e)} testId={`${testId}-${i}`} />;
  return (
    <Reorder.Item value={item} dragListener={false} dragControls={controls} className="relative bg-white rounded-md" as="div">
      {render(item, i, handle)}
    </Reorder.Item>
  );
};

export const moveItem = (list, i, d) => {
  const next = [...list];
  [next[i], next[i + d]] = [next[i + d], next[i]];
  return next;
};

export const SortableList = ({ items, onChange, render, testId, className = "space-y-3" }) => {
  const onMove = (i, d) => onChange(moveItem(items, i, d));
  return (
    <Reorder.Group axis="y" values={items} onReorder={onChange} className={className} as="div">
      {items.map((item, i) => <SortItem key={item.id} item={item} i={i} count={items.length} onMove={onMove} render={render} testId={testId} />)}
    </Reorder.Group>
  );
};
